import { ApiService } from "./ApiService";
import { RateAgreementStateInfo } from "../types/RateAgreementStateInfo";

const baseUrl = "/services/contactform/api/rateagreement";
class RateAgreementService extends ApiService {
    async getRateAgreementInformation(): Promise<RateAgreementStateInfo> {
        const response = await fetch(`${baseUrl}/info`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const rateAgreementState = await this.handleResponse(response);
        return rateAgreementState.json();
    }
}

export default new RateAgreementService();
